import axios from '@/axios'

const actions = {
  setEvents: ({ commit }) => {
    return axios
      .events
      .fetch({})
      .then((response) => {
        commit('events', response)
      })
  },
  setCurrentEventId: ({ commit, dispatch, rootGetters }, id) => {
    commit('currentEventId', id)
    // Papéis são POR EVENTO: ao trocar de evento, recarrega os papéis do
    // usuário logado. Sem isso, os papéis do evento anterior ficavam "vazando"
    // no localStorage (juiz num evento via botões de juiz em todos os outros).
    const user = rootGetters['users/getUser']
    if (id && user && user.id) {
      dispatch('users/setUser', { user_id: user.id }, { root: true })
    }
  },
  setEventSummary: ({ commit }, eventId) => {
    if (!eventId) {
      commit('eventSummary', [])
      return Promise.resolve()
    }
    return axios
      .events
      .summary(eventId)
      .then((response) => {
        commit('eventSummary', Array.isArray(response) ? response : [])
      })
      .catch((error) => {
        console.log('-----------error-----------', error)
        commit('eventSummary', [])
      })
  },
  setDeleteEvent: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .events
      .post
      .deleteEvent(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch((error) => {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null // 401/403 (sem permissao) ou erro de rede
      })
  },
  fetchEventDuration: (context, eventId) => {
    if (!eventId) return Promise.resolve(null)
    return axios
      .events
      .post
      .getDuration({ event_id: eventId })
      .then((response) => response)
      .catch(() => null) // sem permissao (nao-staff) ou erro: sem duracao
  },
  setCreateEvent: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .events
      .post
      .createEvent(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch((error) => {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setUpdateEvent: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .events
      .post
      .updateEvent(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch((error) => {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  setEventImage: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .events
      .post
      .setImage(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch((error) => {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },
  fetchEventImage: (context, eventId) => {
    return axios
      .events
      .post
      .getImage({ event_id: eventId })
      .then((response) => (response && response.image) || '')
      .catch((error) => {
        console.log('-----------error-----------', error)
        return ''
      })
  }
}

export default actions
